import React, { FC, useEffect } from 'react';

import { Icon } from '@iconify/react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Button from '~/components/atoms/buttons/Button';
import AfterSignUpStepperV2 from '~/modules/extension/components/AfterSignUpStepper/variants/V2';
import WorksEverywhereAnimation from '~/modules/extension/components/WorksEverywhereAnimation';
import useGetSteps from '~/modules/extension/hooks/useGetSteps';
import analytics from '~/services/analytics';
import extension from '~/services/Extension';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const ExtensionIcon = extension.getIcon();

type Props = {
  onSubmit: () => void;
};

const PromoModal: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation('extension');
  const { afterSignUpSteps } = useGetSteps('modal');

  useEffect(() => {
    analytics.trackEvent('extension - promo modal show');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.stepper}>
        <AfterSignUpStepperV2 steps={afterSignUpSteps} />
      </div>

      <div className={styles.content}>
        <div className={styles.content__box}>
          <Typography
            variant={Typographies.HEADLINE_MEDIUM}
            className={styles.title}
            component="div"
          >
            {t('promo_modal.title', 'Use JustDone Tools on Any Website')}
          </Typography>

          <Button
            onClick={onSubmit}
            size="small"
            variant="contained"
            className={styles.button}
          >
            <ExtensionIcon className={styles.button__icon} />
            &nbsp;&nbsp;
            {t('general:get_free_extension', 'Get Free Extension')}
          </Button>

          <div className={styles.rating}>
            <div className={styles.rating__stars}>
              {[...Array(5)].map((i) => (
                <Icon
                  className={styles.rating__stars_item}
                  key={i}
                  icon="material-symbols:star-rounded"
                />
              ))}
            </div>
            <Typography
              variant={Typographies.LABEL_LARGE}
              className={styles.rating__description}
              component="div"
            >
              4.5/5 •{' '}
              {t('overview.hero_reviews', {
                reviews_amount: 425,
                defaultValue: 'Based on {{reviews_amount}} reviews',
              })}
            </Typography>
          </div>
        </div>

        <div className={styles.content__box}>
          <div className={styles.asset}>
            <WorksEverywhereAnimation />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
